import actionTypes from './actiontypes';
import config from '../../../config/config';

const {
  REQUEST_ROOM_RECORDINGS,
  RECEIVE_ROOM_RECORDINGS,
  SERVER_ERROR_OCURED,
  CLEAR_ERRORS
} = actionTypes;

function hasErrored(errors) {
  return {
    type: SERVER_ERROR_OCURED,
    errors: errors
  };
}

export function fetchRoomRecordings(token, forTranscriptions = false, searchObject = null) {
  return function(dispatch) {
    let queryString = '';
    if (searchObject) {
      queryString = Object.keys(searchObject).map(key => key + '=' + searchObject[key]).join('&');
    }
    dispatch({ type: REQUEST_ROOM_RECORDINGS });
    return fetch(`${config.URI}/api/v1/room_recordings?transcriptions=${forTranscriptions}&${queryString}`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        } else {
          return res.json();
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          // sort the recordings based on start time
          let roomRecordings = res.data.room_recordings.sort((a, b) => new Date(parseInt(b.recording_started_at) * 1000) - new Date(parseInt(a.recording_started_at) * 1000));
          dispatch({ type: RECEIVE_ROOM_RECORDINGS, roomRecordings });
        } else if (res.errors) {
          console.error(res.errors);
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))

        console.error(error)
      });
  };
}

export function deleteRoomRecording(token, id) {
  return function(dispatch) {
    return fetch(`${config.URI}/api/v1/room_recordings/${id}`, {
      method: 'DELETE',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json;charset=UTF-8'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        } else {
          return res.json();
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(fetchRoomRecordings(token));
        } else if (res.errors) {
          console.error(res.errors);
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))

        console.error(error)
      });
  };
}

export function clearErrors() {
  return function(dispatch) {
    dispatch({ type: CLEAR_ERRORS });
  }

}



// WEBPACK FOOTER //
// src/routes/RoomRecordings/actions/index.js